<template>
    <b-container id="project-schema-page" fluid>
        <b-row class="">
            <b-col cols="12">
                <div class="border-bottom mb-3 pb-3">
                    <h3>프로젝트 스키마 관리</h3>
                    <p class="fw-400 text-secondary mb-0">
                        프로젝트별 입력 스키마 및 다국어 문자열을 관리합니다.
                        배정 콘솔의 신청 질문 = 스키마 입력 값, 언어별 문구 = 다국어 문자열.
                    </p>
                </div>
            </b-col>
        </b-row>

        <b-tabs v-model="currentTab" card>
            <b-tab :title="$t('스키마 입력 값 관리')">
                <manage-schema-input/>
            </b-tab>
            <b-tab :title="$t('다국어 문자열 관리')">
                <manage-locale-string/>
            </b-tab>
        </b-tabs>
    </b-container>
</template>

<script>

import ManageLocaleString
    from '@shared/components/admin/pages/Management/ProjectSchema/LocaleString/ManageLocaleString.vue';
import ManageSchemaInput
    from '@shared/components/admin/pages/Management/ProjectSchema/SchemaInput/ManageSchemaInput.vue';

const ROUTE_NAME = 'ManagingProjectSchema';
// 첫 탭이 기본값 — URL 에 tab 이 없거나 잘못되면 첫 탭으로 본다
const TAB_NAMES = ['schemaInput', 'localeString'];
const tabOf = (query) => (TAB_NAMES.includes(query.tab) ? query.tab : TAB_NAMES[0]);

export default {
    name: 'ProjectSchema',
    components: {
        ManageSchemaInput,
        ManageLocaleString
    },
    data() {
        return {
            currentTab: TAB_NAMES.indexOf(tabOf(this.$route.query)),
            // 탭별 마지막 query — 다른 탭에 다녀와도 검색어·페이지·필터를 되살린다(새로고침하면 사라진다)
            tabQueries: {},
        };
    },
    computed: {},
    watch: {
        // URL → 탭 (뒤로가기·사이드바 재클릭·직접 입력). 기본 탭은 tab 키를 생략한다
        $route(to, from) {
            if (to.name !== ROUTE_NAME || from.name !== ROUTE_NAME) return;
            // 떠나는 탭의 query 를 기억한다(탭 클릭은 push 직전 query, 뒤로가기는 바뀌기 전 query 가 from)
            if (tabOf(from.query) !== tabOf(to.query)) this.tabQueries[tabOf(from.query)] = {...from.query};
            if (this.dropTabKey()) return;
            this.currentTab = TAB_NAMES.indexOf(tabOf(to.query));
        },
        // 탭 클릭 → URL (그 탭의 마지막 query 를 되살린다)
        currentTab(index) {
            const tab = TAB_NAMES[index];
            if (!tab || tab === tabOf(this.$route.query)) return;
            const query = {...(this.tabQueries[tab] || {}), tab};
            if (tab === TAB_NAMES[0]) delete query.tab;
            this.$router.push({name: ROUTE_NAME, query}).catch(() => {});
        }
    },
    created() {
        this.dropTabKey();
    },
    beforeDestroy() {
    },
    methods: {
        // 없는 탭 이름·기본(첫) 탭 이름은 URL 에서 지운다(자동 보정이라 replace, 다른 필터 키는 유지)
        dropTabKey() {
            const {tab, ...rest} = this.$route.query;
            if (tab == null || (TAB_NAMES.includes(tab) && tab !== TAB_NAMES[0])) return false;
            this.$router.replace({name: ROUTE_NAME, query: rest}).catch(() => {});
            return true;
        }
    }
};
</script>

<style lang="scss">
</style>
